import React from 'react';

export const ShimmerLoading: React.FC = () => {
  return (
    <div className="gr-shimmer-container">
      {[1, 2, 3].map((item) => (
        <div key={item} className="gr-shimmer-card">
          <div className="gr-shimmer-header gr-shimmer-anim" />
          
          <div className="gr-shimmer-row">
            <div className="gr-shimmer-player gr-shimmer-anim" />
            <div className="gr-shimmer-score">
              <div className="gr-shimmer-score-box gr-shimmer-anim" />
              <div className="gr-shimmer-score-box gr-shimmer-anim" />
            </div>
          </div>
          
          <div className="gr-shimmer-row">
            <div className="gr-shimmer-player gr-shimmer-anim" style={{ width: '40%' }} />
            <div className="gr-shimmer-score">
              <div className="gr-shimmer-score-box gr-shimmer-anim" />
              <div className="gr-shimmer-score-box gr-shimmer-anim" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
